import './_sub-collection-menu.scss';
import component from './sub-collection-menu';

export default component;
